// This file serves as a central hub for re-exporting pre-typed Redux hooks.
import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, AppStore, RootState } from './createStore';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();

// Hook to check if the store has been rehydrated
export const useRehydrated = () => {
  return useAppSelector((state) => {
    // Check if the persist state has been rehydrated
    return !!(state as any)._persist?.rehydrated;
  });
}; 